class StateSelectorDialog {
    constructor() {
        this.dialog = document.querySelector('.state-selector-dialog');
        this.openButton = document.querySelectorAll('.state-selector-button');
        this.buttonText = document.querySelectorAll('.state-selector-button-text');
        this.closeButton = document.querySelector('.state-selector-dialog-close');
        this.searchInput = document.querySelector('.state-selector-dialog-search-input');
        this.statesList = document.querySelector('.state-selector');
        this.stateItems = this.statesList ? this.statesList.querySelectorAll('li') : [];
        this.checkoutId = ((key) => key ? localStorage.getItem(key) : null)(
            Object.keys(localStorage).find(key => key.endsWith('checkoutId'))
        );
        this.init();
        this.updateButtonText();
    }

    init() {
        if (!this.dialog || !this.openButton || !this.closeButton || !this.searchInput || !this.statesList) {
            console.error('StateSelectorDialog: Missing required elements.');
            return;
        }

        this.openButton.forEach(button => {
            button.addEventListener('click', () => this.openDialog());
        });
        this.closeButton.addEventListener('click', () => this.closeDialog());
        this.searchInput.addEventListener('input', () => this.filterStates());
        this.statesList.addEventListener('click', (event) => this.onStateClick(event));
    }

    updateButtonText() {
        const selectedState = localStorage.getItem('state');
        this.buttonText.forEach(buttonText => {
            buttonText.textContent = selectedState;
        });
    }

    toggleBodyOverflow(hide) {
        document.body.style.overflow = hide ? 'hidden' : 'auto';
    }

    openDialog() {
        this.toggleBodyOverflow(true);
        const storedState = localStorage.getItem('state');
        if (storedState) {
            const currentSelected = this.statesList.querySelector('.selected');
            const newSelected = this.statesList.querySelector(`[data-value="${storedState}"]`);
            if (currentSelected && currentSelected !== newSelected) {
                currentSelected.classList.remove('selected');
            }
            newSelected?.classList.add('selected');
        }
        this.dialog.showModal();
    }

    closeDialog() {
        this.dialog.close();
        this.toggleBodyOverflow(false);
    }

    filterStates() {
        const searchValue = this.searchInput.value.toLowerCase();
        this.stateItems.forEach(item => {
            const stateName = item.textContent.toLowerCase();
            item.style.display = stateName.includes(searchValue) ? 'block' : 'none';
        });
    }

    onStateClick(event) {
        const stateItem = event.target.closest('li');

        if (this.checkoutId && window.client) {
            window.client.checkout.fetch(this.checkoutId).then((checkout) => {

                if (checkout.lineItems.length > 0) {
                    this.clearCart();
                }
                if (stateItem && this.statesList.contains(stateItem)) {
                    localStorage.setItem('state', stateItem.dataset.value);
                    window.location.reload();
                }
            });
        }
        else {
            localStorage.setItem('state', stateItem.dataset.value);
            window.location.reload();
        }
    }

    clearCart() {
        if (this.checkoutId && window.client) {
            window.client.checkout.fetch(this.checkoutId)
                .then((checkout) => {
                    const lineItemIds = checkout.lineItems.map(item => item.id);
                    if (lineItemIds.length > 0) {
                        window.client.checkout.removeLineItems(this.checkoutId, lineItemIds);
                        window.location.reload();
                        return checkout;
                    } else {
                        return checkout;
                    }
                })
                .catch((error) => {
                    console.error('Error clearing cart:', error);
                });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => new StateSelectorDialog());